import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthFromGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", ""));
    const sessionId = params.get("session_id");
    const redirectTo = sessionStorage.getItem("google-auth-redirect") || "/dashboard";

    if (!sessionId) {
      navigate("/login");
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/google/exchange`, {}, {
          headers: { Authorization: `Bearer ${sessionId}` }
        });

        if (res.data.token) {
          setAuthFromGoogle(res.data.token, res.data.user);
          sessionStorage.removeItem("google-auth-redirect");
          navigate(redirectTo);
        } else {
          navigate("/login");
        }
      } catch {
        navigate("/login");
      }
    };

    exchangeSession();
  }, [navigate, setAuthFromGoogle]);

  return (
    <div className={`min-h-screen flex items-center justify-center ${'bg-slate-50'}`}>
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-blue-500 animate-spin mx-auto mb-4" />
        <p className={'text-slate-600'}>Signing you in with Google...</p>
      </div>
    </div>
  );
}
